<template>
  <FormDialog
    :visible="visible"
    :title="dialogTitle"
    :width="500"
    @close="close"
  >
    <el-form
      ref="directGroupForm"
      :model="form"
      :rules="rules"
      label-width="100px"
      label-position="right"
      @submit.native.prevent
    >
      <el-form-item label="账户组名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入账户组名称"
          maxlength="64"
        />
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button
        class="indiv-btn"
        type="primary"
        size="small"
        :loading="submitting"
        @click="onSubmit"
      >
        提交
      </el-button>
    </template>
  </FormDialog>
</template>

<script>
/** 添加/重命名账户组弹窗 */
export default {
  name: "DirectGroupAddDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /** 有值则为编辑模式，提交走 direct_group_updateTwo；名称回显用列表 initialName */
    groupId: {
      type: [Number, String],
      default: null,
    },
    /** 编辑时由列表行传入的分组名称 */
    initialName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      submitting: false,
      form: {
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {
    isEdit() {
      return this.groupId != null && this.groupId !== "";
    },
    dialogTitle() {
      return this.isEdit ? "修改分组名称" : "添加账户组";
    },
  },
  watch: {
    visible(v) {
      if (!v) {
        this.form.name = "";
        this.submitting = false;
        return;
      }
      if (this.isEdit) {
        this.form.name =
          this.initialName != null ? String(this.initialName) : "";
        this.$nextTick(() => {
          const f = this.$refs.directGroupForm;
          if (f) {
            f.clearValidate();
          }
        });
      } else {
        this.form.name = "";
        this.$nextTick(() => {
          const f = this.$refs.directGroupForm;
          if (f) {
            f.clearValidate();
          }
        });
      }
    },
  },
  methods: {
    apiToken() {
      try {
        const t = JSON.parse(localStorage.getItem("token") || "{}");
        return t.apiToken || this.$store.state.usermsg.apiToken;
      } catch (e) {
        return this.$store.state.usermsg.apiToken;
      }
    },
    close() {
      this.$emit("close");
    },
    onSubmit() {
      const form = this.$refs.directGroupForm;
      if (!form) {
        return;
      }
      form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.submitting) {
          return;
        }
        if (this.isEdit && (this.groupId == null || this.groupId === "")) {
          return;
        }
        this.submitting = true;
        const req = this.isEdit
          ? this.$request.post("/api_eval/direct_group_updateTwo", {
              token: this.apiToken(),
              id: this.groupId,
              name: String(this.form.name || "").trim(),
            }, { skipToken: true, rawResponse: true })
          : this.$request.post("/api_eval/direct_group_add", {
              token: this.apiToken(),
              name: String(this.form.name || "").trim(),
            }, { skipToken: true, rawResponse: true });
        req
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.$emit("success", { mode: this.isEdit ? "edit" : "add" });
              this.close();
            } else {
              this.$alert(
                (res.data && (res.data.message || res.data.msg)) || "操作失败",
                {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true,
                }
              );
            }
          })
          .catch(() => {
            this.$alert("网络异常，请稍后重试", {
              confirmButtonText: "确定",
              type: "error",
              center: true,
            });
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/client/grouping/DirectGroupAddDialog.vue